import React from 'react';
import { ICatalogItemState } from 'src/entities/catalog';
import { useAuth } from 'src/features/auth';
import { useOpenCatalogItem } from 'src/features/catalogItem/view';

export const MAP_MARKER_CLICK_HANDLER_NAME = '__handleMapMarkerClick';

export const useMapMarkerClickHandler = () => {
  const authCase = useAuth();
  const openCatalogItem = useOpenCatalogItem({ authCase });

  React.useEffect(() => {
    window[MAP_MARKER_CLICK_HANDLER_NAME] = (catalogItem: ICatalogItemState, event: PointerEvent) => {
      event.stopPropagation?.();
      event.preventDefault?.();
      openCatalogItem(catalogItem);
    };

    return () => {
      delete window[MAP_MARKER_CLICK_HANDLER_NAME];
    };
  }, [openCatalogItem]);
};
